import { db } from "./firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";

export function getUserQuotes(userId) {
  const quotesCollection = collection(db, "users", userId, "quote");
  const quotesQuery = query(quotesCollection, orderBy("createdAt", "desc"));
  return quotesQuery; // Return the Firestore query object
}

export function createNewQuote(userId, author, content) {
  const quotesCollection = collection(db, "users", userId, "quote");
  return addDoc(quotesCollection, {
    author: author,
    content: content,
    createdAt: new Date(),
  });
}

export function deleteQuote(userId, quoteId) {
  const quoteDoc = doc(db, "users", userId, "quote", quoteId);
  return deleteDoc(quoteDoc);
}

export function updateQuote(userId, quoteId, newAuthor, newContent) {
  const quoteDoc = doc(db, "users", userId, "quote", quoteId);
  return updateDoc(quoteDoc, {
    author: newAuthor,
    content: newContent,
  });
}
